import React from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faTimes } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { useScreeshots } from "../queries/use-screeshots";

const ScreenshotsFilter = ({ selectedId, onChange }) => {
  const { id } = useParams();
  const { isLoading, isError, data: screenshots, error } = useScreeshots(id);

  if (isLoading) {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 mb-4 text-sm text-gray-400">
        Loading screenshots…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-2xl p-4 mb-4 text-sm text-red-700">
        Error: {error.message}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 mb-4">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs uppercase tracking-wide text-gray-400 font-semibold flex items-center gap-1.5">
          <FontAwesomeIcon icon={faCamera} className="w-3 h-3" />
          Filter by screenshot
        </span>
        {selectedId && (
          <button
            type="button"
            onClick={() => onChange(null)}
            className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800"
          >
            <FontAwesomeIcon icon={faTimes} className="w-3 h-3" />
            Clear selection
          </button>
        )}
      </div>
      {screenshots.length === 0 ? (
        <div className="text-sm text-gray-400 italic">
          No screenshots available.
        </div>
      ) : (
        <div className="flex gap-2 flex-wrap">
          {screenshots.map((s) => (
            <button
              type="button"
              className={classNames(
                "rounded-lg overflow-hidden border-2 transition",
                selectedId === s.id
                  ? "border-primary ring-2 ring-primary ring-opacity-30"
                  : "border-gray-200 hover:border-gray-300"
              )}
              key={s.id}
              onClick={() => onChange(s.id)}
              title={s.title}
            >
              <img
                className="h-28 w-auto object-contain bg-gray-50"
                src={s.url}
                alt={s.title}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
export default ScreenshotsFilter;
